import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issue-high-balance-item',
    templateUrl: './issues-high-balance-grid-item.component.html'
})
export class IssuesHighBalanceGridItemComponent implements OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['highBalancePage']) {
                    this.page = +queryParams['highBalancePage'];
                }
            }));

        this.getData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.issuePaygHighBalancePaged(this.clientId, this.page, this.pageSize, this.siteId).then(
            result => {
                this.dataService.issuesHighBalanceGridItemComponentResolved.next(result.items.length > 0);
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
            },
            error => {
                this.dataService.issuesHighBalanceGridItemComponentResolved.next(false);
            }
        );
    }

    onInfoClick() {
        swal({
            title: 'High credit status',
            html: '<p style="text-align: left;">These consumers have high credit on their PAYG device. This could mean they are not budgeting effectively and may need guidance on available top-up options.</p>\
            <p style="text-align: left;">In extreme circumstances, very high credit can be an indication of fraudulent activities such as money laundering.</p>\
            <p style="text-align: left;">Call our customer services team if you would like some advice about consumers in high credit.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
